@if (matchingRelease$ | async; as matchingRelease) {
  @if (newerLatestProductionRelease$ | async; as latestRelease) {
    <div class="alert alert-info my-0 text-center rounded-0 shadow-sm">
      <strong>New release!</strong>
      It is recommended to install the latest release, v{{ latestRelease.version }}.
      <ng-container *ngTemplateOutlet="bundlesLink"></ng-container>
    </div>
  }
  @if (matchingRelease.supported === false) {
    <div class="alert alert-warning my-0 text-center rounded-0 shadow-sm">
      <strong>Unsupported release!</strong>
      The release v{{ matchingRelease.version }} is no longer supported.
      <ng-container *ngTemplateOutlet="bundlesLink"></ng-container>
    </div>
  }
} @else {
  @if (motionMasterVersion$ | async) {
    <div class="alert alert-warning my-0 text-center rounded-0 shadow-sm">
      <strong>Unsupported release!</strong>
      This release is no longer supported.
      <ng-container *ngTemplateOutlet="bundlesLink"></ng-container>
    </div>
  }
}

<ng-template #bundlesLink>
  @if ((isOblacDrivesBrand$ | async) && isElectronApp) {
    Download the latest version from
    <a
      href="https://bundles.synapticon.com"
      class="d-inline-flex align-items-center"
      target="_blank"
      rel="noreferrer noopener"
    >
      bundles.synapticon.com </a
    >.
  }
</ng-template>
